<template>
  <div
    class="w-min h-min py-3 pl-3 pr-4 flex border shadow-md border-primary-50 dark:border-dark-400"
    style="border-radius: 0.5rem"
  >
    <div :class="isLightMode() ? 'load-anime' : 'load-anime-dark '" />
    <div class="text-xl my-auto ml-3" :class="isLightMode() ? 'text-animation' : 'text-animation-dark'">Loading...</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'

export default defineComponent({
  setup() {
    const { isLightMode } = useConfigStatePresenter()

    return {
      isLightMode
    }
  }
})
</script>

<style lang="postcss" scoped>
.load-anime {
  width: 40px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 8px solid #9f91f1;
  border-right-color: #e3e3e3;
  animation: load 1s infinite linear;
}

@keyframes load {
  to {
    transform: rotate(1turn);
  }
}

.text-animation {
  animation: colorChange 1s infinite;
}

@keyframes colorChange {
  0% {
    color: #1f2937;
  }
  50% {
    color: #6b7280;
  }
  100% {
    color: #1f2937;
  }
}

.load-anime-dark {
  width: 40px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 8px solid #5545b8;
  border-right-color: #272727;
  animation: load 1s infinite linear;
}

.text-animation-dark {
  animation: colorChangeDark 1s infinite;
}

@keyframes colorChangeDark {
  0% {
    color: #dfdfdf;
  }
  50% {
    color: #9ca3af;
  }
  100% {
    color: #dfdfdf;
  }
}
</style>
